export default function DivPoze({ obj }) {
    return (
        <div className="relative group">
            <img src={obj.img} alt={obj.subtext} className="w-full h-auto" />
            <p className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                {obj.subtext}
            </p>
        </div>
    );
}
